<template>
	<div>
		<PageHeader
			:data="{
				name: contact.first_name + ' ' + contact.last_name,
				breadcrumbs: [
					{ name: 'Home', to: '/' },
					{ name: 'County contacts', to: '/county-contacts' },
				],
			}"
		/>
		<form @submit.prevent="updateContact">
			<div class="row">
				<div class="col-4">
					<div class="card mb-2">
						<div class="card-body">
							<div class="row mb-0 pb-1 border-bottom pb-2 mb-2">
								<div class="col-2">
									<h1 class="p-0 m-0" role="button">🧑</h1>
								</div>
								<div class="col-10">
									<h4 class="mb-0 p-0">{{ contact.first_name }} {{ contact.last_name }}</h4>
									<a :href="'mailto:' + contact.email">{{ contact.email }}</a>
								</div>
							</div>
							<div class="row">
								<div class="col-12 d-flex justify-content-between mb-2">
									<span>Created</span>
									<span>{{ contact.created_at | localDate }}</span>
								</div>
								<div class="col-12 d-flex justify-content-between mb-2">
									<span>Status</span>
									<span v-if="contact.status === 'active'" class="badge badge-success bg-success">
										active
									</span>
									<span v-if="contact.status === 'deleted'" class="badge badge-danger bg-danger">
										active
									</span>
								</div>
							</div>
						</div>
					</div>
					<div class="card d-none">
						<div class="card-body">
							<div
								class="form-check form-switch col-12 d-flex justify-content-between align-items-center ps-0"
							>
								<label class="form-check-label" for="main">Unsubscribe </label>
								<input
									class="form-check-input"
									v-model="unsubscribed"
									type="checkbox"
									id="unsubscribed"
								/>
							</div>
						</div>
					</div>
				</div>
				<div class="col-8">
					<div class="card mb-2">
						<div class="card-body">
							<div class="row">
								<div class="col-12">
									<div class="d-flex justify-content-start align-items-center">
										<h5 class="p-0 m-0 me-1">Contact info</h5>
										<button
											data-bs-toggle="offcanvas"
											data-bs-target="#offcanvasActivities"
											aria-controls="offcanvasActivities"
											class="btn btn-link btn-sm p-0 m-0 mt-1"
											title="Contact history of changes"
											type="button"
										>
											<font-awesome-icon :icon="['fas', 'history']" />
										</button>
									</div>

									<div class="form-group">
										<label for="">First Name</label>
										<input
											type="text"
											class="form-control"
											name="first_name"
											v-model="contact.first_name"
											required
										/>
									</div>
									<div class="form-group">
										<label for="">Last Name</label>
										<input type="text" class="form-control" v-model="contact.last_name" required />
									</div>
									<div class="form-group">
										<label for="">Address</label>
										<input type="text" class="form-control" v-model="contact.address" />
									</div>
									<div class="form-group">
										<label for="">Email</label>
										<input type="email" class="form-control" v-model="contact.email" required />
									</div>
									<div class="form-group">
										<label for="">Phone</label>
										<input type="text" class="form-control" v-model="contact.phone" />
									</div>
									<div class="form-group">
										<label for="">Title</label>
										<input type="text" class="form-control" v-model="contact.title" required />
									</div>
								</div>
							</div>
						</div>
					</div>
					<button
						v-if="authUser.permissions.includes('CONTACT_UPDATE')"
						type="submit"
						class="btn btn-primary float-end"
					>
						Update
					</button>
				</div>
			</div>
		</form>

		<Activities :key="activityKey" :subjectType="'App\\Models\\CountyContact'" :subjectId="$route.params.id" />
	</div>
</template>

<script>
import PageHeader from '@/components/layout/PageHeader'
import { mapState } from 'vuex'
import restApi from '../../api/index.js'
import { handleErrors } from '../../actions/helpers'
import Activities from '@/components/Activities'

export default {
	name: 'CountyContactEdit',
	components: { PageHeader, Activities },
	data() {
		return {
			loading: false,
			contact: {
				name: 'Contact',
			},
			activityKey: 0,
			unsubscribed: 0,
		}
	},
	computed: {
		...mapState(['authUser', 'storageUrl']),
	},
	created() {
		this.loadingClient = true
	},

	methods: {
		// Get Client
		getContact() {
			restApi
				.get(`/county-contacts/${this.$route.params.id}`)
				.then(({ data }) => {
					this.contact = data
					if (this.contact.unsubscribed === 'yes') {
						this.unsubscribed = true
					} else {
						this.unsubscribed = false
					}
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		// Update Client
		updateContact() {
			restApi
				.put(`/county-contacts/${this.$route.params.id}`, this.contact)
				.then(({ data }) => {
					this.contact = data
					this.activityKey++
					this.$swal.fire({
						icon: 'success',
						title: 'county contact successfully updated!',
						timer: 3000,
					})
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},
	},
	mounted: function() {
		this.getContact()
	},
	watch: {
		unsubscribed: function() {
			if (this.unsubscribed) {
				this.contact.unsubscribed = 'yes'
			} else {
				this.contact.unsubscribed = 'no'
			}
		},
	},
	filters: {
		localDate: function(value) {
			if (!value) return ''
			value = new Date(value)
			return value.toLocaleDateString()
		},
		localDateTime: function(value) {
			if (!value) return ''
			value = new Date(value)
			return value.toLocaleString()
		},
	},
}
</script>
